export const CHANGE_PASSWORD_CONFIGURACION='CHANGE_PASSWORD_CONFIGURACION';
export const SHOW_MESSAGE_CONFIGURACION='SHOW_MESSAGE_CONFIGURACION';
export const HIDE_MESSAGE_CONFIGURACION='HIDE_MESSAGE_CONFIGURACION';